// Build the campaigns-review list query (pagination + sort; the status=review filter is added by the hook).
export const getCampaignsReviewQuery = meta => ({
  limit: meta.rowsPerPage,
  offset: meta.page * meta.rowsPerPage,
  sort_by: meta.sortBy,
  sort_order: meta.sortOrder,
})
